<div class="informations-container">
  <mat-accordion>
    <mat-expansion-panel
      #ingredientsPanel
      class="mat-elevation-z1"
      (opened)="panelIngredientsState = true"
      (closed)="panelIngredientsState = false"
      [expanded]="true"
    >
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <h2>{{ 'SEMANTIZATION.TAB_TITLE' | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <app-semantization-block
          [variant]="variant"
          [market]="market"
          [lang]="lang"
          [domain]="domain"
          [marketingFoods]="marketingFoods"
          [yieldUnits]="yieldUnits"
        ></app-semantization-block>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel class="mat-elevation-z1" [expanded]="false">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title id="RecipesModifyMoreInfosNutritionalBtn">
          <h2>{{ 'NUTRITION.TITLE' | translate }} {{ 'NUTRITION.RECIPE_LABEL' | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <app-nutritional-information *ngIf="formVariant" [formVariant]="formVariant"></app-nutritional-information>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
